import { IModel } from "../../../Core/ModelStoring/Model";

import { ICalculationFunctionModelAccessor } from "./CalculationFunctionCallContext";

export class CalculationFunctionModelAccessor implements ICalculationFunctionModelAccessor {
    readonly #model: IModel;

    public constructor(model: IModel) {
        this.#model = model;
    }

    public get(path: string, name: "children"): undefined | string[] {
        if (name !== "children") {
            throw new Error("Invalid field name: 'children' only allowed in 2nd getCached parameter");
        }

        return this.#model.getChildren(path);
    }
}
